import { css, styled, useDimension } from '@openeducation/oe-rn-themes';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { OEButton } from '../../../atoms';
import { ml, mt } from '../../../style-utils';

interface FeedbackActionsProps {
  disabled: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function FeedbackActions({
  disabled,
  isLoading,
  onClose,
  onSubmit,
}: FeedbackActionsProps) {
  const { t } = useTranslation();
  const { isLargeScreen } = useDimension();

  return (
    <Container isLargeScreen={isLargeScreen}>
      <OEButton onPress={onSubmit} disabled={disabled} loading={isLoading}>
        {t('mobile.feedback.send')}
      </OEButton>

      <OEButton
        type="dark0"
        mode="text"
        onPress={onClose}
        style={[ml(isLargeScreen ? 16 : 0), mt(isLargeScreen ? 0 : 16)]}
      >
        {t('mobile.feedback.cancel')}
      </OEButton>
    </Container>
  );
}

const Container = styled.View<{ isLargeScreen: boolean }>`
  ${({ isLargeScreen }) =>
    isLargeScreen
      ? css`
          align-items: center;
          width: 100%;
          flex-direction: row;
          justify-content: flex-start;
        `
      : css`
          align-items: center;
        `}
`;
